/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BusinessUnitOverviewDto } from './BusinessUnitOverviewDto';
import {
    BusinessUnitOverviewDtoFromJSON,
    BusinessUnitOverviewDtoFromJSONTyped,
    BusinessUnitOverviewDtoToJSON,
    BusinessUnitOverviewDtoToJSONTyped,
} from './BusinessUnitOverviewDto';

/**
 * 
 * @export
 * @interface BusinessUnitOverviewDtoPagedResponseDto
 */
export interface BusinessUnitOverviewDtoPagedResponseDto {
    /**
     * 
     * @type {Array<BusinessUnitOverviewDto>}
     * @memberof BusinessUnitOverviewDtoPagedResponseDto
     */
    items?: Array<BusinessUnitOverviewDto> | null;
    /**
     * 
     * @type {number}
     * @memberof BusinessUnitOverviewDtoPagedResponseDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof BusinessUnitOverviewDtoPagedResponseDto
     */
    pageIndex?: number;
    /**
     * 
     * @type {number}
     * @memberof BusinessUnitOverviewDtoPagedResponseDto
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the BusinessUnitOverviewDtoPagedResponseDto interface.
 */
export function instanceOfBusinessUnitOverviewDtoPagedResponseDto(value: object): value is BusinessUnitOverviewDtoPagedResponseDto {
    return true;
}

export function BusinessUnitOverviewDtoPagedResponseDtoFromJSON(json: any): BusinessUnitOverviewDtoPagedResponseDto {
    return BusinessUnitOverviewDtoPagedResponseDtoFromJSONTyped(json, false);
}

export function BusinessUnitOverviewDtoPagedResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessUnitOverviewDtoPagedResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(BusinessUnitOverviewDtoFromJSON)),
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'pageIndex': json['pageIndex'] == null ? undefined : json['pageIndex'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function BusinessUnitOverviewDtoPagedResponseDtoToJSON(json: any): BusinessUnitOverviewDtoPagedResponseDto {
    return BusinessUnitOverviewDtoPagedResponseDtoToJSONTyped(json, false);
}

export function BusinessUnitOverviewDtoPagedResponseDtoToJSONTyped(value?: BusinessUnitOverviewDtoPagedResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(BusinessUnitOverviewDtoToJSON)),
        'totalCount': value['totalCount'],
        'pageIndex': value['pageIndex'],
        'pageSize': value['pageSize'],
    };
}

